import { css } from 'styled-components';
import { ColorBrandBlue1 } from 'autogen/design-tokens/tokens';

export interface IMatasStripes {
    position?: string;
    stripesWidth?: string;
    stripeWidth?: string;
    stripeHeight?: string;
    stripeColor1?: string;
    stripeColor2?: string;
}

const stripes = css<IMatasStripes>`
    position: relative;

    &:before {
        content: '';
        position: absolute;
        height: ${({ stripeHeight = '30px' }) => stripeHeight};
        width: ${({ stripeWidth = '100%' }) => stripeWidth};

        ${({ position = 'top' }) => {
            if (position === 'top') {
                return css`
                    left: 0;
                    right: 0;
                    top: 0;
                `;
            }
            if (position === 'bottom') {
                return css`
                    left: 0;
                    right: 0;
                    bottom: 0;
                `;
            }
            if (position === 'left') {
                return css`
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: auto;
                `;
            }
            if (position === 'right') {
                return css`
                    top: 0;
                    bottom: 0;
                    right: 0;
                    left: auto;
                `;
            }
            return css`
                left: 0;
                right: 0;
                top: 0;
            `;
        }}

        ${({ stripeColor1 = '#bfd3e7', stripeColor2 = 'transparent', stripesWidth = '8px', position = 'top' }) => {
            if (position === 'top' || position === 'bottom')
                return css`
                    background: repeating-linear-gradient(
                        135deg,
                        ${stripeColor1},
                        ${stripeColor1} ${stripesWidth},
                        ${stripeColor2} 0,
                        ${stripeColor2} ${Number.parseInt(stripesWidth) * 2}px
                    );
                `;
            if (position === 'right' || position === 'left')
                return css`
                    background: repeating-linear-gradient(
                        -135deg,
                        ${stripeColor1},
                        ${stripeColor1} ${stripesWidth},
                        ${stripeColor2} 0,
                        ${stripeColor2} ${Number.parseInt(stripesWidth) * 2}px
                    );
                `;

            return css`
                background: repeating-linear-gradient(
                    135deg,
                    ${stripeColor1},
                    ${stripeColor1} ${stripesWidth},
                    ${stripeColor2} 0,
                    ${stripeColor2} ${Number.parseInt(stripesWidth) * 2}px
                );
            `;
        }};
    }
`;

export default stripes;
